<template>
    <div class="col-md-5 cart-box spmb-20">
        <div
            class="col-xs-4 col-md-2 product-quantity-item"
            style="z-index: 0"
        >
            <input
                v-model="count"
                type="text"
            />

            <span class="input-group-btn-vertical">
                <button
                    @click="count++"
                    class="btn-up"
                    type="button"
                >
                    +
                </button>

                <button
                    @click="count > 0 ? count-- : 0"
                    class="btn-down"
                    type="button"
                >
                    -
                </button>
            </span>
        </div>

        <div
            class="col-xs-4 col-md-3"
            style="font-family: sans-serif; font-size: 15px; font-weight: bolder"
        >
            ￥{{ Number(priceJpy).toLocaleString() }}
        </div>

        <div class="col-xs-4 col-md-3 p-0">
            <button
                :disabled="count === 0"
                v-btn-loading="loading"
                class="btn-alltobag btn btn-accent"
                style="z-index: 0; padding: 9px 0"
                @click="addCartTableSet()"
            >
                まとめてレンタルする
            </button>
        </div>
    </div>
</template>

<script>
import linq from 'linq'
import CollectionTableSet from '../../models/CollectionTableSet'
import ProfessionalAddCartModal from '../../components/professionalDesign/ProfessionalAddCartModal'
import BtnLoading from '../../directives/BtnLoading.vue'
import { addCartItem } from '../../services/CartService'

export default {
    name: 'collection-cart',

    data() {
        return {
            count: 0,
            loading: false,
        }
    },

    props: {
        tableSet: {
            type: String,
        },
        priceJpy: {
            type: String,
        },
    },

    methods: {
        async addCartTableSet() {
            this.loading = true
            this.setMessage()
            const tableSet = new CollectionTableSet(JSON.parse(this.tableSet))
            const items = linq
                .from(tableSet.items)
                .select((x) => {
                    return { item_id: x.itemId, count: x.count * this.count }
                })
                .toArray()
            const is_success = await addCartItem(items)
            this.count = 0

            if (is_success) {
                this.addCartAction()
                alert('カートに商品を追加しました')
            }
            this.loading = false
        },

        addCartAction() {
            window.cartDrop.$emit('getCartItems')
        },

        setMessage(message = '') {
            this.message = message
        },
    },

    directives: {
        BtnLoading,
    },

    components: {
        ProfessionalAddCartModal,
    },
}
</script>

<style lang="scss" scoped>
.cart-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    float: right;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
    margin-right: 35px;
    @media screen and (max-width: 576px) {
        margin-right: 0;
        padding-bottom: 25px;
        padding-right: 30px;
    }
}

.item {
    margin-right: 15px;
    width: 20%;
    @media screen and (max-width: 576px) {
        margin-right: 12px;
    }
}

.filter-size-name {
    font-size: 13px;
    color: #000000;
    @media screen and (max-width: 576px) {
        min-width: 40px;
    }
}

.product-price {
    font-size: 17px;
    color: #000000;
    margin-left: 10px;
}

.btn-alltobag button {
    background-color: #fff;
    color: #000;
    text-align: right;
    font-weight: 700;
    &:hover {
        color: #fff;
        border-color: #262634;
        background-color: #262634;
    }
}

button {
    width: 100%;
    flex: unset;
    font-size: 12px;
    padding: 7px 10px 7px;
    font-weight: bold;
    @media screen and (max-width: 1127px) {
        font-size: 11px;
        padding: 7px 4px 7px;
    }
    @media screen and (max-width: 576px) {
        padding: 10px;
    }
}

.product-quantity-item {
    position: relative;
    display: inline-block;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    margin-right: 30px;
    padding-right: 0;
    input {
        margin-bottom: 0;
        width: 100%;
        height: 43px;
        text-align: center;
        border: 1px solid #dfdfdf;
        font-size: 14px;
        font-weight: 700;
        color: #262634;
        font-family: 'Oswald', sans-serif;
        padding: 14px 15px 14px;
    }
}

.input-group-btn-vertical {
    button {
        position: absolute;
        left: 100%;
        margin: 0 0 0 4px;
        width: 22px;
        height: 22px;
        padding: 0;
        color: #262634;
        font-size: 10px;
        text-align: center;
        border: 1px solid #dfdfdf;
        background-color: #ffffff;
        &:hover {
            color: #ffffff;
            border-color: #262634;
            background-color: #262634;
        }
    }
    .btn-up {
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        i {
            top: 6px;
        }
    }
    .btn-down {
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 22px;
        i {
            top: 6px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/professionalDesign/ProfessionalCollectionCart.vue